import { Box, Card, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Tabs, Tab, InputAdornment, Button, Checkbox } from '@mui/material';
import LayoutAccessManagement from 'components/structure/LayoutAccessManagement';
import { useState } from 'react';
import leftIcon from 'assets/user-access/leftIcon.svg'
import rightIcon from 'assets/user-access/rightIcon.svg'
import CustomBlueCheckbox from 'utils/CustomBlueCheckbox';
import { useNavigate } from 'react-router-dom';

const RoleAssignSubmoduleEdit = () => {
    const navigate = useNavigate();

    const columns = [
        { id: 'module', label: 'Module' },
        { id: 'action', label: 'Action' },
    ];

    const [data, setdata] = useState(
        [{
            modules: { id: 1, moduleName: 'Country', canCreate: false, canEdit: true, canUpdate: true, canDelete: true },
        },

        {
            modules: { id: 1, moduleName: 'Name Field', canCreate: false, canEdit: true, canUpdate: true, canDelete: true },
        },
        {
            modules: { id: 1, moduleName: 'Address Field', canCreate: false, canEdit: true, canUpdate: true, canDelete: true },
        },
        {
            modules: { id: 1, moduleName: 'Attachments', canCreate: false, canEdit: true, canUpdate: true, canDelete: true },
        }
        ],

    )

    const VerticalLine = () => {
        return (
            < Box
                sx={{
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#0E2B63',
                    opacity: 0.2,
                    margin: '0 auto'
                }}
            />
        );
    };
    const handleToggle = (id, field, value) => {

    };

    const onEdit = (row) => {
        navigate('/roleAssign/editSubmodule/' + row?.id)
    }

    const handlePage = (page) => {
        // alert(page)
        //call API and update data and pagenumber
    }
    return (
        <LayoutAccessManagement title="Access Management">
            <Card
                className='Access-Management-Layout'
                sx={{
                    backgroundColor: "#f3f5f8",
                    color: "white",
                    marginBottom: "30px",
                    padding: "20px",
                    border: "none",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <Box sx={{ width: "948px", marginTop: "40px", marginBottom: "40px", borderRadius: '16px', backgroundColor: "#fff", height: "auto" }}>
                    <Box className="roleAssignHeader">
                        Survey Approver
                    </Box>
                    <VerticalLine />
                    <Box className="roleAssignHeader2" sx={{ fontWeight: 700, padding: '23px 0px 20px 0px' }}>
                        Role Owner
                        <Box className="roleAssignHeader2" sx={{ fontWeight: 500 }}>Local ESG Admin</Box>
                    </Box>
                    <VerticalLine />
                    <Box className="roleAssignHeader2" sx={{ fontWeight: 700, padding: '20px 0px 17px 0px' }}>Assigned Functionality</Box>
                    <Box className="roleAssignTable">
                        <TableContainer component={Paper} sx={{ overflow: 'unset !important' }}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#102A63' }}>
                                    <TableRow>
                                        {columns?.map((column, index) => (
                                            <>
                                                {column?.id == 'module' ?
                                                    <TableCell
                                                        sx={{ color: '#fff', display: "flex", alignItems: "center", borderRight: '1px solid #ddd', justifyContent: "space-between" }}
                                                        key={column.id}>
                                                        <Box>
                                                            <img onClick={() => navigate(-1)} src={leftIcon} style={{ paddingRight: "12px", cursor: "pointer" }} />
                                                            {column.label}
                                                        </Box>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <CustomBlueCheckbox
                                                                checked={false}
                                                            />

                                                            <span>Page {1}</span>
                                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                <img onClick={() => handlePage('left')} src={leftIcon} style={{ paddingRight: "12px", cursor: "pointer" }} />
                                                                <img onClick={() => handlePage('right')} src={rightIcon} style={{ paddingRight: "12px", cursor: "pointer" }} />
                                                            </Box>
                                                        </Box>

                                                    </TableCell>
                                                    : <TableCell
                                                        sx={{ color: '#fff', borderRight: '1px solid #ddd', textAlign: "center" }}
                                                        key={column.id}>
                                                        {column.label}
                                                    </TableCell>}
                                            </>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row, ind) => (
                                        <>
                                            <TableRow key={ind}>
                                                <TableCell sx={{
                                                    borderRight: '1px solid #ddd',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                    maxWidth: 300,
                                                    minWidth: 200,
                                                }}><Box className="roleAssignTableSubModule">{row?.modules?.moduleName}</Box></TableCell>
                                                <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center", width: "52px" }}>
                                                    <CustomBlueCheckbox
                                                        // checked={row?.modules?.canCreate}
                                                        checked={true}
                                                        onClick={() => handleToggle(row?.modules?.canCreate, 'module')}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box sx={{ paddingTop: "30px" }}>
                        <VerticalLine />
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "cemter", margin: "40px 10px" }}>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 130,
                                minHeight: 54,
                                background: "#737D86",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#737D86",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={(e) => navigate(-1)}
                        >
                            {"BACK"}
                        </Button>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 156,
                                minHeight: 54,
                                background: "#112A63",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#112A63",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={(e) => navigate('/roleAssign')}
                        >
                            {"UPDATE"}
                        </Button>
                    </Box>
                </Box>
            </Card>
        </LayoutAccessManagement >
    );
};

export default RoleAssignSubmoduleEdit;
